// extracted by mini-css-extract-plugin
export default {"has-shipping":"DetailsForm_has-shipping__A1uUO"};